import React, { ComponentPropsWithoutRef, FC } from 'react';
import { Box, Button, Icon, Typography } from '@fullstory/components';
import { NoResultsContainer } from './NoResultsContainer';
import { ResourceListResourceType } from '../ResourceList';
import { intl } from '@fullstory/intl';

export interface EmptyStateProps {
  onCreate?: () => void;
  resourceType: ResourceListResourceType;
  icon: ComponentPropsWithoutRef<typeof Icon>['name'];
  description: string;
}

const emptyStateMessages: {
  [key in ResourceListResourceType]: { text: string; createButtonText: string };
} = {
  Alert: {
    text: intl.formatMessage({
      defaultMessage: "You haven't created any Alerts",
      id: 'iVKiPP',
    }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Alert', id: 'CNr5B5' }),
  },
  Dashboard: {
    text: intl.formatMessage({
      defaultMessage: "You haven't created any Dashboards",
      id: '9nzmUM',
    }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Dashboard', id: 'hmp7Ga' }),
  },
  Funnel: {
    text: intl.formatMessage({ defaultMessage: "You haven't created any Funnels", id: '6P869t' }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Funnel', id: 'ptNN94' }),
  },
  Heatmap: {
    text: intl.formatMessage({ defaultMessage: "You haven't created any Heatmaps", id: 'MmHaLb' }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Heatmap', id: '1RuU3s' }),
  },
  Journey: {
    text: intl.formatMessage({ defaultMessage: "You haven't created any Journeys", id: 'Xjtl0f' }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Journey', id: 'SfCCER' }),
  },
  Metric: {
    text: intl.formatMessage({ defaultMessage: "You haven't created any Metrics", id: 'vtqoDu' }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Metric', id: 'QbD3Ci' }),
  },
  Segment: {
    text: intl.formatMessage({ defaultMessage: "You haven't created any Segments", id: '2cTY2S' }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Segment', id: 'CBf0eH' }),
  },
  Page: {
    text: intl.formatMessage({ defaultMessage: "You haven't created any Pages", id: 'RHIvg6' }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create a Page', id: '0Hfu7Y' }),
  },
  Retention: {
    text: intl.formatMessage({
      defaultMessage: "You haven't created any Retention charts",
      id: '8h/+9d',
    }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create Retention', id: 'herLeZ' }),
  },
  Space: {
    text: intl.formatMessage({
      defaultMessage: 'You haven’t created any Spaces',
      id: '83hwtS',
    }),
    createButtonText: intl.formatMessage({ defaultMessage: 'Create Space', id: 'v3aFf1' }),
  },
};

export const EmptyState: FC<EmptyStateProps> = ({ onCreate, resourceType, icon, description }) => (
  <NoResultsContainer data-component="EmptyState">
    <Icon
      name={icon}
      color="secondary"
      // @ts-ignore
      size={60}
    />
    <Typography variant="body1">{emptyStateMessages[resourceType].text}</Typography>
    <Box paddingTop={8} paddingBottom={16}>
      <Typography variant="body2" color="neutrals-n8">
        {description}
      </Typography>
    </Box>
    {onCreate && (
      <Button variant="fill-primary" onClick={onCreate}>
        {emptyStateMessages[resourceType].createButtonText}
      </Button>
    )}
  </NoResultsContainer>
);
